import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { BaseRequestResponse } from '@/_types/services';
import type { ILastState } from '@/Interfaces/Data';
import { GET_ENTREGADORES_BY_ASSOCIATE } from '../constants';

type EntregadoresByAssociateParams = {
  entregaId: string;
};

interface EntregadoresByAssociateResponse {
  deliverymanDistanceToPlaceInMeters: number;
  nome: string;
  _id: string;
  page?: ILastState['page'];
  establishments: {
    establishmentName?: string;
    deliveryQuantity?: number;
  }[];
}

const getEntregadoresByAssociate = ({
  entregaId,
}: EntregadoresByAssociateParams) => {
  return apiClient
    .get<BaseRequestResponse<EntregadoresByAssociateResponse[]>>(
      `/entregadores/by-associate`,
      { params: { entregaId } },
    )
    .then(response => response.data.data)
    .catch(handleResponseThrowError());
};

type GetEntregadoresByAssociate = Awaited<
  ReturnType<typeof getEntregadoresByAssociate>
>;

export const useGetEntregadoresByAssociate = (
  params: EntregadoresByAssociateParams,
  options: Omit<
    UseQueryOptions<
      GetEntregadoresByAssociate,
      unknown,
      GetEntregadoresByAssociate,
      (string | EntregadoresByAssociateParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_ENTREGADORES_BY_ASSOCIATE, params],
    queryFn: () => getEntregadoresByAssociate(params),
    ...options,
  });
};
